import './index.css'
import React from 'react'
import classNames from 'classnames'

const DocumentFileName = ({ id, value, className, ...rest }) => {
  const beautyFileName = () => {
    const fileName = value
    if (fileName.length > 15) {
      return fileName.substring(0, 6) + '...' + fileName.substring(fileName.length - 6, fileName.length)
    } else {
      return fileName
    }
  }

  return (
    <span
      className={classNames('default-fileName-cell', className, 'document-filename-tooltip')}
      style={{ whiteSpace: 'nowrap' }}
      {...rest}
    >
      {beautyFileName()}
      <div className="document-filename-tooltip">
        <span className="document-filename-tooltip-content">{value}</span>
      </div>
    </span>
  )
}

export default DocumentFileName
